import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Spin } from 'antd';
import { useAppContext, APP_ACTIONS, userId } from "../../context/appContext";

import fetchBotCases from "../common/helpers/fetch-bot-cases";
import removeBotCase from "../common/helpers/remove-bot-case";
import removeBotCaseAll from "../common/helpers/remove-bot-case-all";

import fetchAccumulatorCases from "../common/helpers/fetch-accumulator-cases";
import removeAccumulatorCase from "../common/helpers/remove-accumulator-case";
import removeAccumulatorCaseAll from "../common/helpers/remove-accumulator-case-all";


const tableHeaderStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", paddingLeft: 20, width: "20%" }
const tableRowStyle = { fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20 }

const EdgeCaseViewer = ({ selectedBot, setDisplayCaseViewerSection }) => {
    console.log({
        selectedBot
    })

    const {
        dispatch,
    } = useAppContext();

    const [unhandledOrders, setUnhandledOrders] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!selectedBot) return;

        dispatch({
            type: APP_ACTIONS.SET_EDGE_CASE_ALERT,
            payload: { notificationAlert: false, bot_id: selectedBot.id },
        })

        console.log(selectedBot)
        setLoading(true);
        let action;
        if (selectedBot.type === 'marketmaker' || selectedBot.type === 'triangular') {
            action = fetchBotCases;
        }
        else if (selectedBot.type === 'accumulator') {
            action = fetchAccumulatorCases;
        }

        action({ bot_id: selectedBot.id }).then(res => {
            setUnhandledOrders(res);
            setLoading(false);
        }).catch(err => {
            console.log({ err })
            setLoading(false);
        })

    }, [selectedBot])
    return (
        <>
            <div style={{ height: "90%" }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 15 }}>
                    <div style={{}}>
                        <div style={{ display: "flex", cursor: "pointer", flexDirection: "row", gap: 10 }}>
                            <div style={{ color: "grey", fontSize: 17, }}>
                                <div onClick={() => { setDisplayCaseViewerSection(false); }}> <span style={{ textDecoration: "underline", marginRight: 6 }}> My bot list {'>'} Advanced {'>'} </span> <span style={{ color: "white", fontSize: 14 }}>{selectedBot.name} {'>'} Edge Case Viewer</span></div>
                                <div style={{ fontSize: 13, color: "rgb(180, 180, 180)" }} >View orders failed to get placed. Edge case handler tries to place those orders at particular intervals.</div>
                                <div style={{ fontSize: 13, color: "rgb(180, 180, 180)" }} >You can remove any order if you don't want the handler to create it.</div>

                            </div>
                        </div>
                    </div>

                    <Button onClick={() => {
                        setLoading(true);

                        let action;
                        if (selectedBot.type == 'marketmaker' || selectedBot.type == 'triangular') action = removeBotCaseAll;
                        else if (selectedBot.type == 'accumulator') action = removeAccumulatorCaseAll;

                        action({ bot_id: selectedBot.id }).then(() => {
                            setUnhandledOrders({});
                            setLoading(false);
                        }).catch(err => {
                            console.log({ err })
                            setLoading(false);
                        })
                    }} style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">Remove All</Button>
                </div>
                <div style={{ display: "flex", flexDirection: "row", height: "70%", width: "100%", padding: 10 }}>
                    <div style={{ display: "flex", flexDirection: "column", borderRadius: 5, width: "100%" }}>
                        <div style={{ maxHeight: 800, overflowY: "auto", }}>
                            {loading ? <Spin size="large" style={{ marginLeft: 20 }} /> : <table style={{ width: "100%", }}>
                                <tr>
                                    <th style={tableHeaderStyle} >SYMBOL</th>
                                    <th style={tableHeaderStyle} >SIDE</th>
                                    <th style={tableHeaderStyle} >SIZE</th>
                                    <th style={tableHeaderStyle} >PRICE</th>
                                    <th style={tableHeaderStyle} >ACTION</th>
                                </tr>
                                {Array.isArray(unhandledOrders) && unhandledOrders.map((order, index) => {
                                    return <tr>
                                        <td style={{ fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20, width: "20%" }}>{order.symbol}</td>
                                        <td style={{ fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20, width: "20%" }}>{order.side}</td>
                                        <td style={{ fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20, width: "20%" }}>{order.size}</td>
                                        <td style={{ fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20, width: "20%" }}>{order.price || '-'}</td>
                                        <td style={{ fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20, width: "20%" }}>
                                            <Button style={{ backgroundColor: "#161616", color: "white" }} onClick={() => {

                                                let newUnhandledOrders = unhandledOrders.filter((order, i) => i !== index);
                                                setUnhandledOrders(newUnhandledOrders);

                                                let action;
                                                if (selectedBot.type == 'marketmaker' || selectedBot.type == 'triangular') action = removeBotCase;
                                                else if (selectedBot.type == 'accumulator') action = removeAccumulatorCase;

                                                action({ bot_id: selectedBot.id, symbol: order.symbol, side: order.side })

                                            }} >Remove</Button>
                                        </td>
                                    </tr>
                                }
                                )}

                            </table>}

                        </div>

                    </div>
                </div>
            </div>
            <div>
            </div>
        </>
    );
};

export default EdgeCaseViewer;